import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSession } from '../session/session-provider';
import { publicAnalyticsBridge } from './public-analytics';

export function PublicAnalyticsObserver() {
  const { status } = useSession();
  const { pathname, search, hash } = useLocation();

  useLayoutEffect(() => {
    publicAnalyticsBridge.observe(status, { pathname, search, hash });
  }, [status, pathname, search, hash]);

  return null;
}
